export default "__VITE_ASSET__CypMhJ32__"